import apiClient from "@/api/apiClient";

export const getBrands = async () => {
  const result = await apiClient.get("/api/brands");
  return result.data;
};

export const saveBrandDiscount = async (brand, discount) => {
  const result = await apiClient.post("/api/brands", { brand, discount });
  return result.data;
};
